export default "__VITE_ASSET__h_zUcymo__"